import { TwoFactorMethod } from '@/types/misc';

type BaseUserSignupData = {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  middle_name?: string;
  phone?: string;
  date_of_birth?: string;
  user_role: UserRole;
};

export type BorrowerUserSignupData = BaseUserSignupData & {
  user_role: UserRole.BORROWER;
};

export type BaseInvestorUserSignupData = BaseUserSignupData & {
  user_role: UserRole.INVESTOR_INDIVIDUAL | UserRole.INVESTOR_COMPANY;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zip_code: string;
  country?: string;
};

export type IndividualInvestorUserSignupData = BaseInvestorUserSignupData & {
  user_role: UserRole.INVESTOR_INDIVIDUAL;
};

export type CompanyInvestorUserSignupData = BaseInvestorUserSignupData & {
  user_role: UserRole.INVESTOR_COMPANY;
  ein: string;
  company_name: string;
};

export type InvestorUserSignupData = IndividualInvestorUserSignupData | CompanyInvestorUserSignupData;

export type UserSignupData = BorrowerUserSignupData | InvestorUserSignupData;

export enum UserRole {
  BORROWER = 'BORROWER',
  INVESTOR_INDIVIDUAL = 'INVESTOR_INDIVIDUAL',
  INVESTOR_COMPANY = 'INVESTOR_COMPANY',
}

export type User = {
  id: number;
  email: string;
  first_name: string;
  middle_name: string | null;
  last_name: string;
  user_role: UserRole;
  email_verified: boolean;
  phone: string;
  date_of_birth: string;
  is_reviewer?: boolean;
  is_escrow?: boolean;
  is_liveness_verified?: boolean; // TODO: verify if this is the correct field name
  has_invitation_code?: boolean; // TODO: verify if this is the correct field name
};

export enum UserClientRole {
  BORROWER = 'BORROWER',
  INVESTOR = 'INVESTOR',
}

export type CompleteVerificationData = {
  email: string;
  code: string;
  twofa_method: TwoFactorMethod;
};

export type ForgotPasswordData = {
  email: string;
  user_role: UserClientRole;
};

export type ResetPasswordData = {
  email: string;
  code: string;
  new_password: string;
  user_role: UserClientRole;
};
